<ng-container *ngIf="modifiers$ | async"></ng-container>
<ng-container *ngIf="materials$ | async"></ng-container>
<!-- <ng-container *ngIf="page$ | async"></ng-container> -->

<div mat-dialog-title>
  <span class="title dialog-title" i18n>База материалов</span>
  <button mat-button class="mat-icon-button" (click)="dialogRef.close([])" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- MENU -->
<div class="p-4 flex flex-row space-x-4 justify-between items-center">
  <div class="flex flex-row space-x-2 justify-between items-center flex-1">
    <mat-form-field appearance="outline" class="dense-input no-subscript flex-1" floatLabel="never">
      <input
        data-testid="search"
        matInput
        ngModel
        #filter
        (ngModelChange)="find$.next($event)"
        placeholder="Поиск"
        i18n-placeholder />
      <div matSuffix>
        <button mat-icon-button (click)="find$.next(filter.value)">
          <mat-icon class="secondary-text">search</mat-icon>
        </button>
      </div>
    </mat-form-field>
  </div>

  <ng-container *ngIf="dialogData.showPrices">
    <div class="flex flex-row space-x-3 items-center">
      <div i18n>Цена</div>
      <mat-form-field appearance="outline" class="dense-input no-subscript">
        <!-- <mat-label></mat-label> -->
        <input
          matInput
          ngModel
          (ngModelChange)="priceFilter$.next([$event, priceFilter$.value[1]])"
          autocomplete="off"
          type="number"
          i18n-placeholder
          placeholder="от" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="dense-input no-subscript">
        <!-- <mat-label></mat-label> -->
        <input
          matInput
          ngModel
          (ngModelChange)="priceFilter$.next([priceFilter$.value[0], $event])"
          autocomplete="off"
          type="number"
          i18n-placeholder
          placeholder="до" />
      </mat-form-field>
    </div>
  </ng-container>
</div>
<!-- MENU END -->

<mat-divider> </mat-divider>

<mat-dialog-content class="ps no-padding">
  <as-split direction="horizontal" [unit]="'pixel'" *ngIf="groups$ | async as groups">
    <as-split-area [size]="320">
      <csl-group-matrial-tree
        class="ps flex-1"
        [groupMaterials]="groups"
        [focusedGroupId]="focusedGroupId"
        (selectedGroupChange)="onGroupSelect($event); paginator.firstPage()">
      </csl-group-matrial-tree>
    </as-split-area>

    <as-split-area>
      <div class="h-full flex flex-col items-stretch" cslPerfectScrollbar>
        <mat-table
          #table
          matSort
          cslPerfectScrollbar
          (matSortChange)="sort$.next({ active: $event.active, direction: $event.direction })"
          [dataSource]="dataSource"
          class="material-list-table flex-1">
          <!-- Select Column -->
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let item">
              <mat-checkbox
                data-testid="materialCheckbox"
                [ngModel]="isSelected(item)"
                (change)="toggleSelection(item)"
                [disabled]="
                  isExcludeExists(item) || (item.quantityInStock < 0 && dialogData.showQuantityInStock)
                "></mat-checkbox>
            </mat-cell>
          </ng-container>

          <!-- Material Texture Column -->
          <ng-container matColumnDef="texture">
            <mat-header-cell *matHeaderCellDef i18n>Текстура</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <csl-texture-viewer
                [textureLink]="item.textureLink"
                [cropTextureLink]="item.cropTextureLink"
                [color]="item.color"></csl-texture-viewer>
            </mat-cell>
          </ng-container>

          <!-- Material Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef i18n>Наименование</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span
                #matName
                [matTooltip]="item.name"
                [matTooltipDisabled]="!showFullNameTooltip(matName)"
                class="text-truncate h6 p-1"
                >{{ item.name }}</span
              >
            </mat-cell>
          </ng-container>

          <!-- Material Article Column -->
          <ng-container matColumnDef="article">
            <mat-header-cell *matHeaderCellDef i18n>Артикул</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span
                #matArticle
                [matTooltip]="item.name"
                [matTooltipDisabled]="!showFullNameTooltip(matArticle)"
                class="text-truncate"
                >{{ item.article }}</span
              >
            </mat-cell>
          </ng-container>

          <!-- Material Price Column -->
          <ng-container matColumnDef="price">
            <mat-header-cell mat-sort-header *matHeaderCellDef i18n>Цена</mat-header-cell>
            <mat-cell *matCellDef="let item">
              {{ item.price | number : '1.0-2' }} {{ dialogData.currencyName }}/{{ item.measureName }}
            </mat-cell>
          </ng-container>

          <!--Quantity Material Stock Column-->
          <ng-container matColumnDef="quantityInStock">
            <mat-header-cell *matHeaderCellDef i18n>Наличие на складе</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span *ngIf="item.quantityInStock > 0"> {{ item.quantityInStock }} {{ item.measureName }} </span>
              <span i18n *ngIf="item.quantityInStock === 0">Под заказ</span>
              <span i18n *ngIf="item.quantityInStock === -1">Нет в наличии</span>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row
            class="material-list-row"
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{ selected: isSelected(row), 'disabled-row': isExcludeExists(row) }"></mat-row>
        </mat-table>

        <mat-divider></mat-divider>

        <mat-paginator
          [length]="totalCount"
          #paginator
          [pageSize]="25"
          [pageSizeOptions]="[10, 25, 50, 100]"
          (page)="page$.next($event)">
        </mat-paginator>
      </div>
    </as-split-area>
  </as-split>
</mat-dialog-content>

<div mat-dialog-actions>
  <button data-test-id="baseMaterialDialogOkButton" mat-raised-button class="mat-accent" (click)="saveAndClose()" i18n
    >ОК</button
  >
  <button data-test-id="baseMaterialDialogCancelButton" mat-button (click)="dialogRef.close([])" i18n>ОТМЕНА</button>
</div>
